// extracted by mini-css-extract-plugin
export default {"input_group":"style_input_group__LlPaE"};